function AddItemScreen() {
  return (
    <iframe
      src="https://additem.thesmalldatastore.com"
      style={{ width: "100vw", height: "100vh" }}
    ></iframe>
  );
}

export default AddItemScreen;
